import { deliveryLinks } from "../data/constants";

export const DeliveryServices = () => {
  return (
    <ul className="text-sm md:text-lg font-[600] flex md:flex-row items-center justify-center gap-8 md:gap-10 px-2 w-full mx-auto">
      {deliveryLinks.map(({ name, url, img, width }) => (
        <li
          key={name}
          className="hover:opacity-100 hover:-translate-y-[0.5px] md:opacity-80 transition-opacity"
        >
          <a href={url} rel="noreferrer noopener" target="_blank">
            <img src={img} alt={name} className={width} />
          </a>
        </li>
      ))}
    </ul>
  );
};
